import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n, { setupI18n, getElementPlusLocale } from './i18n'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 初始化 i18n 设置
setupI18n()

const app = createApp(App);
app.use(router); // 注册路由
app.use(i18n); // 注册国际化

// 注册 Element Plus 并设置初始语言
const elementLocale = getElementPlusLocale()
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(ElementPlus, {
  locale: elementLocale
});

app.mount('#app');
